// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__OmTUP","btnOffer":"AddProduct_btnOffer__OvM4s"};